// Shared RPC endpoint configuration
import { ENV_CONSTS } from './env-consts.ts';

export type RpcEndpoint = {
  url: string;
  name: string;
  priority: number;
};

// Get RPC endpoints from environment variables or use defaults
export const getBaseRpcEndpoints = (): string[] => {
  // If VITE_BASE_RPC_ENDPOINTS is provided, use it
  if (ENV_CONSTS.BASE_RPC_ENDPOINTS) {
    return ENV_CONSTS.BASE_RPC_ENDPOINTS.split(',').map((endpoint) =>
      endpoint.trim()
    );
  }

  // If separate primary and fallback are provided
  if (ENV_CONSTS.BASE_PRIMARY_RPC) {
    const endpoints = [ENV_CONSTS.BASE_PRIMARY_RPC];
    if (ENV_CONSTS.BASE_FALLBACK_RPCS) {
      endpoints.push(
        ...ENV_CONSTS.BASE_FALLBACK_RPCS.split(',').map((endpoint) =>
          endpoint.trim()
        )
      );
    }
    return endpoints;
  }

  // Default fallback endpoints with better rate limits
  return [
    'https://rpc.coinraces.io',
    'https://mainnet.base.org',
    'https://base.api.onfinality.io/public',
    'https://api.zan.top/base-mainnet',
    'https://base.llamarpc.com',
    'https://0xrpc.io/base',
    'https://base.public.blockpi.network/v1/rpc/public',
    'https://base.rpc.subquery.network/public',
    'https://gateway.tenderly.co/public/base',
    'https://rpc.owlracle.info/base/70d38ce1826c4a60bb2a8e05a6c8b20f',
    'https://base.drpc.org',
    'https://base-pokt.nodies.app',
    'https://base.lava.build',
    'https://base.therpc.io',
    'https://base-mainnet.public.blastapi.io',
    'https://base-mainnet.gateway.tatum.io',
    'https://endpoints.omniatech.io/v1/base/mainnet/public',
    'https://developer-access-mainnet.base.org',
    'https://base.gateway.tenderly.co',
    'https://base-rpc.publicnode.com',
  ];
};

// Convert string endpoints to RpcEndpoint objects with names and priorities
export const getBaseRpcEndpointsWithMetadata = (): RpcEndpoint[] => {
  const endpoints = getBaseRpcEndpoints();

  return endpoints.map((url, index) => {
    // Extract provider name from URL for better naming
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    let name = hostname
      .replace(/\./g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());

    // Clean up common patterns
    name = name
      .replace('Base ', '')
      .replace('Api ', 'API ')
      .replace('Rpc ', 'RPC ')
      .replace('Public ', '')
      .replace('Mainnet ', '')
      .replace('Gateway ', '')
      .replace('Developer Access ', '')
      .replace('Endpoints ', '')
      .replace('Omniatech ', 'Omniatech ')
      .replace('Tenderly ', 'Tenderly ')
      .replace('Subquery ', 'Subquery ')
      .replace('Blockpi ', 'BlockPI ')
      .replace('Blastapi ', 'BlastAPI ')
      .replace('Publicnode ', 'PublicNode ')
      .replace('Nodies ', 'Nodies ')
      .replace('Therpc ', 'TheRPC ')
      .replace('Llamarpc ', 'LlamaRPC ')
      .replace('Onfinality ', 'OnFinality ')
      .replace('Zan ', 'ZAN ')
      .replace('Owlracle ', 'Owlracle ')
      .replace('Drpc ', 'DRPC ')
      .replace('Lava ', 'Lava ')
      .replace('Tatum ', 'Tatum ')
      .replace('Omniatech ', 'Omniatech ');

    return {
      url,
      name: name.trim(),
      priority: index + 1,
    };
  });
};
